import { Howl } from "howler";
import store from "../../store/configure-store";

var VOLUME = 0.3;

const soundPaths = {
  jackpotWin: "sounds/rr_jackpot_win.mp3",
  bonusRounds: "sounds/rr_jackpot_win_short.mp3",
  slider: "sounds/slider_click.mp3",
  btnClick: "sounds/btn_click.mp3",
  modalClose: "sounds/mdl_close.mp3",
  turboOn: "sounds/turboON.ogg",
  turboOff: "sounds/turboOFF.ogg",
  cashout: "sounds/cashout.ogg",
  ballDrop: "sounds/drop_ball.mp3",
  pinSound1: "sounds/plink/plink_1.mp3",
  pinSound2: "sounds/plink/plink_2.mp3",
  pinSound3: "sounds/plink/plink_3.mp3",
  pinSound4: "sounds/plink/plink_4.mp3",
  pinSound5: "sounds/plink/plink_5.mp3",
  pinSound6: "sounds/plink/plink_6.mp3",
  pinSound7: "sounds/plink/plink_7.mp3",
  pinSound8: "sounds/plink/plink_8.mp3",
  pinSound9: "sounds/plink/plink_9.mp3",
  pinSound10: "sounds/plink/plink_10.mp3",
  turboPinSound1: "sounds/plink/turboplink_1.ogg",
  turboPinSound2: "sounds/plink/turboplink_2.ogg",
  turboPinSound3: "sounds/plink/turboplink_3.ogg",
  turboPinSound4: "sounds/plink/turboplink_4.ogg",
  turboPinSound5: "sounds/plink/turboplink_5.ogg",
  turboPinSound6: "sounds/plink/turboplink_6.ogg",
  turboPinSound7: "sounds/plink/turboplink_7.ogg",
  turboPinSound8: "sounds/plink/turboplink_8.ogg",
  turboPinSound9: "sounds/plink/turboplink_9.ogg",
  turboPinSound10: "sounds/plink/turboplink_10.ogg",
  pocketSound1: "sounds/pocket/pocket_sound_1.mp3",
  pocketSound2: "sounds/pocket/pocket_sound_2.mp3",
  pocketSound3: "sounds/pocket/pocket_sound_3.mp3",
  pocketSound4: "sounds/pocket/pocket_sound_4.mp3",
  pocketSound5: "sounds/pocket/pocket_sound_5.mp3",
  pocketSound6: "sounds/pocket/pocket_sound_6.mp3",
  pocketSound7: "sounds/pocket/pocket_sound_7.mp3",
  pocketSound8: "sounds/pocket/pocket_sound_8.mp3",
  pocketSound9: "sounds/pocket/pocket_sound_9.mp3",
  turboPocketSound1: "sounds/pocket/turbopocket_sound_1.ogg",
  turboPocketSound2: "sounds/pocket/turbopocket_sound_2.ogg",
  turboPocketSound3: "sounds/pocket/turbopocket_sound_3.ogg",
  turboPocketSound4: "sounds/pocket/turbopocket_sound_4.ogg",
  turboPocketSound5: "sounds/pocket/turbopocket_sound_5.ogg",
  turboPocketSound6: "sounds/pocket/turbopocket_sound_6.ogg",
  turboPocketSound7: "sounds/pocket/turbopocket_sound_7.ogg",
  turboPocketSound8: "sounds/pocket/turbopocket_sound_8.ogg",
  turboPocketSound9: "sounds/pocket/turbopocket_sound_9.ogg"
};

class SoundFxPlayer {
  constructor() {
    this.volumeLevel = VOLUME;
    this.sound_files = {};

    // Initialize Howl instances dynamically
    Object.keys(soundPaths).forEach((key) => {
      this.sound_files[key] = new Howl({
        src: [soundPaths[key]],
        volume: this.volumeLevel,
      });
    });
  }

  /**
   * Plays the filename from SFX folder without .mp3 extension
   *
   * @param {string} soundName
   */
  play(soundName) {
    if (!store.getState().playerSettings.sound_enabled) return;
  
    if (soundName === "slider") {
      // Create a fresh Howl instance to allow rapid playback
      const tempSound = new Howl({
        src: [soundPaths[soundName]],
        volume: this.volumeLevel,
      });
      tempSound.play();
    } else {
      this.sound_files[soundName].play();
    }
  }

  /**
   * Stops the filename from SFX folder without .mp3 extension
   *
   * @param {string} soundName
   */
  stop(soundName) {
    this.sound_files[soundName].stop();
  }

  /**
   *  Sets global volume for all sounds
   * @param {*} level 
   */
  setGlobalVolume(level) {
    for (let sound in this.sound_files) {
      this.sound_files[sound].volume(level);
    }
  }

  /**
   * Sets the volume for given sound
   *
   * @param {string} soundName
   * @param {number} level
   */
  volume(soundName, level) {
    this.sound_files[soundName].volume(level);
  }

  /**
   * Sets the volume for given sound
   *
   * @param {string} soundName
   * @param {boolean} level
   */
  loop(soundName, val) {
    this.sound_files[soundName].loop(val);
  }

  /**
   * Fades sound, from values (0-1 or decimal), to alues (0-1 or decimal), duration miliseconds
   *
   * @param {string} soundName
   * @param {number} from
   * @param {number} to
   * @param {number} duration
   */
  fade(soundName, from, to, duration) {
    this.sound_files[soundName].fade(from, to, duration);
  }
}

const soundFxPlayer = new SoundFxPlayer();
export default soundFxPlayer;
